<template>
    <v-row
            v-if="appointment"
            dense
            class="text-center">
        <v-col
                cols="12"
                class="mb-2">
            <div
                    class="d-flex justify-center flex-row flex-wrap">
                <div
                        v-for="employee in employees"
                        :key="employee.id"
                        class="d-flex justify-center flex-column mx-2"
                        style="max-width: 100px;">
                    <span class="subtitle-2">{{ employee.name }}</span>
                    <v-avatar
                            size="100">
                        <img
                                :src="employee.image"
                                :alt="employee.name">
                    </v-avatar>
                </div>
            </div>
        </v-col>
        <v-col
                cols="12"
                dense>
            <span class="body-1 font-weight-bold">{{ field.tips.title }}</span><br>
            <span class="body-2">{{ field.tips.description }}</span>
            <v-divider />
            <span class="font-weight-bold">Total Service Amount: {{ bookingAmountString }}</span><br>
            <v-chip
                    v-for="preset in field.tips.fixed_presets_config"
                    class="mx-1 my-2"
                    color="primary"
                    @click="setValue(preset.value)">
                {{ preset.text }}
            </v-chip>
            <v-chip
                    v-for="preset in percentagePresets"
                    class="mx-1 my-2"
                    color="primary"
                    @click="setValueByPercentage(preset.value)">
                {{ preset.text }}
            </v-chip>
            <v-divider />
        </v-col>

        <v-col
                col="12"
                class="mt-2"
                dense>
            <v-text-field
                    v-model="value"
                    dense
                    :label="field.tips.label"
                    :error="!!error"
                    :error-messages="error"
                    persistent-hint
                    outlined
                    type="number"
                    @input="error = null">
                <template v-slot:append>
                    <span class="pt-1">{{ currency }}</span>
                </template>
            </v-text-field>
        </v-col>
    </v-row>
</template>

<script>
    import Value from "@/models/value.model";
    import Field from "@/models/field.model";
    import Currency from "@/models/currency.model";
    
    export default {
        name: "FieldTipsComponent",
        props: {
            field: {type: Object, default: () => new Field()},
        },
        data() {
            return {
                value: null,
                error: null,
                selected: 0,
            }
        },
        computed: {
            appointment() {
                return this.$store.forms.getAppointment();
            },
            bookingAmount() {
                if (this.appointment && this.appointment.total && this.appointment.total.sub_total) {
                    return parseFloat(this.appointment.total.sub_total);
                }
                return .0;
            },
            percentagePresets() {
                if (this.bookingAmount > 0) {
                    return this.field.tips.percentage_presets_config;
                } else {
                    return []
                }
            },
            currency() {
                return this.appointment ? this.appointment.currency : null;
            },
            bookingAmountString() {
                const ccy = new Currency({iso: this.currency})
                return ccy.displayAmount(this.bookingAmount);
            },
            employees() {
                if (this.appointment) {
                    const uniqueEmployees = {};
                    for (const factService of this.appointment.services) {
                        uniqueEmployees[factService.employee.id] = {
                            id: factService.employee.id,
                            name: factService.employee.title,
                            image: factService.employee.image
                        }
                    }

                    return Object.values(uniqueEmployees)
                }
                return [];
            }
        },
        watch: {
            value: {
                deep: true,
                handler() {
                    this.getValue().then((value) => {
                        this.$emit('updateValue', value);
                    })
                }
            }
        },
        mounted() {
            if (this.field.value instanceof Value && this.field.value.value) {
                this.value = this.field.value.value.amount || null;
            }
        },
        methods: {
            setValue(value) {
                this.value = value;
                this.error = null;
            },
            setValueByPercentage(value) {
                this.value = this.bookingAmount * (value/100)
                this.error = null;
            },
            /**
             *
             * @returns {Value}
             */
            async getValue() {
                if (this.value === '') {
                    this.value = null;
                }

                if (this.value) {
                    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(this.value)) {
                        this.error = 'Amount should be a number';
                        return new Value({
                            value: this.currentValue(),
                            isValid: false,
                            error: this.error
                        });
                    }

                    if (this.value < 0.3) {
                        this.error = 'Value should be more than 0.3';
                        return new Value({
                            value: this.currentValue(),
                            isValid: false,
                            error: this.error
                        });
                    }

                  
                    if (this.value > 1000000) {
                        this.error = 'Value should be less than 1000000.00';
                        return new Value({
                            value: this.currentValue(),
                            isValid: false,
                            error: this.error
                        });
                    }
                } else {
                    if (!this.field.is_optional) {
                        this.error = 'Mandatory field'
                        return new Value({
                            value: this.currentValue(),
                            isValid: false,
                            error: this.error
                        });
                    }
                }


                return new Value({
                    value: this.currentValue(),
                    isValid: true
                });
            },
            currentValue() {
                return {
                    amount: this.value,
                    currency: this.currency
                }
            },
            isValid() {
                return true;
            },
        }
    }
</script>
<style scoped>
 .question-tips-employee {
    border-radius: 100%;
    border-top-left-radius:  100% !important;
    border-top-right-radius:  100% !important;
}
</style>